/**
 * Created by wanghongxiang on 2017/5/27.
 */
const SsoLogin = r => require.ensure([], () => r(require('@/pages/index/ssoLogin')), 'SsoLogin')
const SpaceSsoLogin = r => require.ensure([], () => r(require('@/pages/index/spaceSsoLogin')), 'SpaceSsoLogin')
const SpaceGXSsoLogin = r => require.ensure([], () => r(require('@/pages/index/spaceGXSsoLogin')), 'SpaceGXSsoLogin')
const SpaceleyaLogin = r => require.ensure([], () => r(require('@/pages/index/spaceleyaLogin')), 'SpaceleyaLogin')
const PositivecardDetail = r => require.ensure([], () => r(require('@/pages/index/positivecard-detail')), 'PositivecardDetail')
const BrithdaycardDetail = r => require.ensure([], () => r(require('@/pages/index/brithdaycard-detail')), 'BrithdaycardDetail')
const PeryearcardDetail = r => require.ensure([], () => r(require('@/pages/index/peryearcard-detail')), 'PeryearcardDetail')
const UnusualWork = r => require.ensure([], () => r(require('@/pages/index/unusualWork')), 'UnusualWork')

export default [
  {
    path: '/ssoLogin',
    name: 'SsoLogin',
    components: {
      default: SsoLogin
    }
  },
  {
    path: '/spaceSsoLogin',
    name: 'SpaceSsoLogin',
    components: {
      default: SpaceSsoLogin
    }
  },
  {
    path: '/spaceGXSsoLogin',
    name: 'SpaceGXSsoLogin',
    components: {
      default: SpaceGXSsoLogin
    }
  },
  {
    path: '/spaceleyaLogin',
    name: 'SpaceleyaLogin',
    components: {
      default: SpaceleyaLogin
    }
  },
  {
    path: '/positivecard-detail',
    name: 'PositivecardDetail',
    components: {
      default: PositivecardDetail
    }
  },
  {
    path: '/brithdaycard-detail',
    name: 'BrithdaycardDetail',
    components: {
      default: BrithdaycardDetail
    }
  },
  {
    path: '/peryearcard-detail',
    name: 'PeryearcardDetail',
    components: {
      default: PeryearcardDetail
    }
  },
  {
    path: '/unusualWork',
    name: 'UnusualWork',
    components: {
      default: UnusualWork
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/home.js